import { api } from 'api/api'
import { apiCampaign } from 'api/campaign/apiCampaign'
import { NOTIFICATION, type SnackKey } from 'config/notifications'
import { CONSTS } from 'config/objectConst'
import { notificationUtils } from 'features/notifications'
import { notifyError } from 'shared/errors'

import { appSelectors } from '../redux/reducers/app'
import {
	campaignsActions,
	campaignsSelectors
} from '../redux/reducers/campaigns'
import store from '../redux/store'
import { app } from './app'
import { filters } from './filters'
import { mapping } from './mapping'

function getContactAddedSnack(fromKey: 'contacts' | string, importId: string) {
	const noteId: '3.4a' | '3.4b' = fromKey === 'contacts' ? '3.4a' : '3.4b'

	const nextSnack = { ...NOTIFICATION[noteId] }
	if ('button' in nextSnack) {
		nextSnack.button.link = nextSnack.button.link.replace('{var}', importId)
	}

	return nextSnack
}

function refreshAccessToken(): Promise<void> {
	const root = store.getState()
	const action = appSelectors.refreshAccessToken(root)

	return action()
}

const getFilterQuery = () => campaignsSelectors.filterQuery(store.getState())

interface GetCampaigns {
	orderby?: ''
	page: 0
	searchValue?: ''
}

async function completeCampaign(
	id: string,
	getCampaigns: GetCampaigns,
	load = api.completeCampaignApi,
	notificationKey: SnackKey = '3.8'
) {
	app.changeTableContentLoaderStatus(true)

	try {
		await load(id)

		await updateCampaigns(id, getCampaigns)

		await refreshAccessToken()

		notificationUtils.showSnack(NOTIFICATION[notificationKey])
	} catch (error) {
		notifyError(error)
	} finally {
		app.changeTableContentLoaderStatus(false)
	}
}

async function updateCampaigns(id: string, getCampaigns: GetCampaigns) {
	if (getCampaigns) {
		await filters.getCampaigns({
			archived: false,
			filter: getFilterQuery(),
			keywords: getCampaigns.searchValue,
			orderby: getCampaigns.orderby,
			skip: getCampaigns.page > 0 ? getCampaigns.page * CONSTS.PAGE_SIZE : 0
		})
	} else {
		const response = (await apiCampaign.getCampaignById(id)) as any
		const payload = mapping.campaignTransform(response.data)
		store.dispatch(campaignsActions.updateOne(payload))
	}
}

export {
	completeCampaign,
	getContactAddedSnack,
	getFilterQuery,
	refreshAccessToken,
	updateCampaigns
}
